import { render, staticRenderFns } from "./SalaNv2Form.vue?vue&type=template&id=64e87c16&scoped=true&"
import script from "./SalaNv2Form.vue?vue&type=script&lang=js&"
export * from "./SalaNv2Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e87c16",
  null
  
)

export default component.exports